<button
  id="advocate-chat-{{cid}}"
  aria-haspopup="true"
  class="{{#if class}}{{class}}{{/if}}"
  role="button">
  {{#if icon_prefix}}
    {{#if icon_name}}
      <span>
        {{>icon uuid=cid prefix=icon_prefix name=icon_name classes=icon_size}}
      </span>
    {{/if}}
  {{/if}}
  {{#if text}}
    <span>{{t text}}</span>
  {{/if}}
  {{#if sr_text}}
    <span class="screen-reader-content">{{t sr_text}}</span>
  {{/if}}
</button>
<div class="advocate-chat-iframe-container"></div>
